<template>
    <v-col :cols="cols" :md="md">
      
      <emc-form-auto-complete 
        v-model="model"
        :items="items"
        :label="label"
        :outlined="outlined"
        :disabled="disabled"
        :error-messages="errorMessages"
        :error="error"
        :loading="loading"
        :hide-no-data="hideNoData"
        :clearable="clearable"
      />

    </v-col>
</template>

<script>
  export default {
    name: 'EmcUtilSelectEnviroment',
    props: {
        cols: { type: [String, Number], default: 12 },
        md: { type: [String, Number], default: 6 },
        value: { type: [String, Number, Object] },
        errorMessages: { type: Array, required: false },
        error: { type: Boolean, required: false },
        disabled: { type: Boolean, required: false },
        outlined: { type: Boolean, required: false },
        item: { type: Object, required: false },
        hideNoData: { type: Boolean, required: false },
        label: { type: String, default: 'Tipo' },
        clearable: { type: Boolean, required: false },
    },
    data () {
      return {
        loading: false,
        items: [
            { id: 'local', name: 'Desenvolvimento'},
            { id: 'production', name: 'Produção' },
            { id: 'staging', name: 'Teste' },
        ],
      }
    },
    computed: {
      model: {
          get() {
              return this.value
          },
          set(val) {
              this.$emit('input', val)
          }
      },
    },
  }
</script>